"use strict"

import React from "react"
import ReactNative from "react-native"
import queryString from "query-string"
import fsConsole from "app/lib/utils/fs-console"
import { switchTab, navigateTo, popToTop } from "app/actions/app"
import config from "app/config"

import Post from "app/views/Post"
import Location from "app/views/Location"
import Activity from "app/views/Activity"
import User from "app/views/User"
import InviteFriends from "app/views/InviteFriends"
import DirectMessages from "app/views/DirectMessages"
import NewMessage from "app/views/NewMessage"
import Conversation from "app/views/Conversation"

import { switchBuddyTab } from "app/actions/buddies"

const { InteractionManager } = ReactNative

export default function handleOpenURL(url, dispatch) {
  if (!url || typeof url === "undefined") {
    return
  }
  var parts = url.split("foodstand://")[1]
  if (!parts) {
    return
  }
  parts = parts.split(/[\/\?]/)

  var params = {}
  if (url.match(/\?/)) {
    var split = url.split(/\?/)
    var qs = split[split.length - 1]
    params = queryString.parse(qs)
  }

  if (config.env.FS_DEBUG) {
    fsConsole.groupCollapsed('%c Deep link to: "' + url + '"', "background: #ddf")
    fsConsole.log("URL parts:", parts)
    fsConsole.log("URL params:", params)
    fsConsole.groupEnd()
  }

  if (parts[0] === "profile") {
    dispatch(navigateTo("profile/", {}, "profile"))
  } else if (parts[0] === "checkin") {
    dispatch(navigateTo("checkin/", {}, "checkin"))
  } else if (parts[0] === "mychallenge") {
    dispatch(navigateTo("mychallenge/", {}, "mychallenge"))
  } else if (parts[0] === "my_challenge") {
    dispatch(navigateTo("mychallenge/", {}, "mychallenge"))
  } else if (parts[0] === "buddies") {
    dispatch(navigateTo("buddies/", {}, "buddies", true))
    if (parts.length > 1 && parts[1] === "requests") {
      dispatch(switchBuddyTab("requests"))
    }
  } else if (parts[0] === "direct-messages") {
    if (parts[1] === "new") {
      // NEW MESSAGE:
      dispatch(
        navigateTo(
          "new_message",
          {
            title: "New Message",
            recipientId: params.recipient_id,
          },
          "profile",
          true
        )
      )
    } else if (parts[1]) {
      // LINK TO EXISTING CONVERSATION:
      dispatch(navigateTo("direct_messages", {}, "profile", true))
      dispatch(navigateTo("conversation", { conversationId: Number(parts[1]) }))
    }
  } else if (parts[0] === "invite-friends") {
    dispatch(navigateTo("invite_friends", {}, "profile"))
    navigateTo("invite_friends", { title: "Invite Friends" }, "profile")
  } else if (parts[0] === "notifications") {
    dispatch(navigateTo("activity", {}, "profile"))
  } else if ((parts[0] === "users" || parts[0] === "user") && parts[1]) {
    dispatch(navigateTo("user", { userId: +parts[1] }, "feed"))
  } else if (parts[0] === "post" && parts[1]) {
    dispatch(navigateTo("post", { postId: +parts[1] }, "feed"))
  } else if (parts[0] === "location" && parts[1]) {
    dispatch(navigateTo("location", { locationId: +parts[1] }, "feed"))
  }
}
